import { ChangeDetectionStrategy, Component, computed, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { MapService } from '../../services/map.service';
import { PROYECTED_CIRCLE, PROYETED_ARROW } from '../markers/config/constants';

@Component({
    selector: 'map-proyected-point',
    standalone: true,
    imports: [ 
      CommonModule, 
      GoogleMapsModule 
    ],
    templateUrl: './proyected-point.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class MapProyectedPointComponent {
    private _mapService: MapService = inject(MapService);

    public projectedPoint = computed<google.maps.LatLngLiteral>(() => this._mapService.projectedPoint());
    public projectedPointRotation = computed<number>(() => this._mapService.projectedPointRotation());

    public projectedPointArrowOptions = signal<google.maps.MarkerOptions>(PROYETED_ARROW());
    public projectedPointCircleOptions = signal<google.maps.MarkerOptions>(PROYECTED_CIRCLE());

    rotateArrow = effect(() => {
      const rotation: number = this.projectedPointRotation();
      this.projectedPointArrowOptions.update((prev: any) => ({ ...prev, icon: { ...prev.icon, rotation }}));
    }, { allowSignalWrites: true })

}